import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./mpngmodal.scss";

const MpngModal = (props) => {
  const {
    onAction = {},
    onCancel = {},
    show = {},
    modalTitle = "",
    lessonName = {},
    modalBody = "",
    modalWarning = "",
    modalButton = "",
    className = "",
    modalWarningCont = ""
  } = props;

  return (
    <Modal className="mpng mpng-modal" show={props.show} onHide={props.onHide}>
      <Modal.Header className="mpng-modal-header" closeButton>
        <Modal.Title className="title">{props.modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="body">
        <p className="mpng-detail">{props.modalBody}</p>
        <p className="mpng-detail">
          {props.modalWarning} <strong>{props.lessonName}</strong> {props.modalWarningCont}?
        </p>
      </Modal.Body>
      <Modal.Footer className="footer">
        <Button variant="ilp-secondary" onClick={props.onCancel}>
          Cancel
        </Button>
        <Button className="ms-2" variant="ilp" onClick={props.onAction}>
          {props.modalButton}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MpngModal;
